import * as React from "react";
import type { SVGProps } from "react";
const SvgSettings05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '1em'}
    height={props.height || '1em'}
    viewBox="0 0 21 21"
    {...props}
  >
    <g fill="none" stroke="CurrentColor" strokeWidth={2}>
      <path
        strokeLinejoin="round"
        d="M1 10.5c0-4.478 0-6.718 1.391-8.109S6.022 1 10.5 1s6.718 0 8.109 1.391S20 6.022 20 10.5s0 6.718-1.391 8.109S14.978 20 10.5 20s-6.718 0-8.109-1.391S1 14.978 1 10.5Z"
        data-name="Caminho 462"
      />
      <path
        d="M7 8.5A1.5 1.5 0 1 1 8.5 7 1.5 1.5 0 0 1 7 8.5Z"
        data-name="Caminho 463"
      />
      <path
        d="M14 15.5a1.5 1.5 0 1 0-1.5-1.5 1.5 1.5 0 0 0 1.5 1.5Z"
        data-name="Caminho 464"
      />
      <path strokeLinecap="round" d="M8.5 7h7" data-name="Caminho 465" />
      <path strokeLinecap="round" d="M12.5 14h-7" data-name="Caminho 466" />
    </g>
  </svg>
);
export default SvgSettings05;
